const POINT_FACTOR = 2;
const PRICE_PER_POINT = 0.10;

export default function useLoyaltyProgram() {

    function calculatePoints(price: number) : number {
        const roundedUpPrice = Math.ceil(price);

        return Math.floor(roundedUpPrice / POINT_FACTOR);
    }

    function calculateLoyaltySaving(price: number) : number {
        return calculatePoints(price) * PRICE_PER_POINT;
    }

    /**
     * Base amount the loyalty bonus is calculated from: the summed price of every line item that is
     * NOT on sale. Shopware flags a discounted (sale) item with a `listPrice.discount` on its calculated
     * price, so those items are skipped. Promotion/voucher lines (negative totals) are kept, matching the
     * existing cart behaviour, so the bonus still reflects the amount actually paid.
     */
    function getNonSaleTotal(lineItems: any[] | null | undefined) : number {
        if (!Array.isArray(lineItems)) {
            return 0;
        }

        return lineItems.reduce((total: number, item: any) => {
            if (item?.price?.listPrice?.discount) {
                return total;
            }
            return total + Math.ceil(item?.price?.totalPrice ?? 0);
        }, 0);
    }

    return {
        calculatePoints,
        calculateLoyaltySaving,
        getNonSaleTotal,
    };
}